import { Breadcrumb, HeaderToolbar } from "@xola/ui-kit";
import React from "react";
import { useHistory } from "react-router-dom";
import { ColumnLayout } from "../../components/Layout/ColumnLayout";
import { GlobalSettings } from "../../components/Resources/GuideManagement/GlobalSettings";
import { Page } from "../Page";

export const GuideSettingsPage = () => {
    const history = useHistory();
    const handleGuideManagementLinkClick = () => {
        history.push("/resources/guides");
    };

    return (
        <Page title="Guide Management">
            <ColumnLayout>
                <HeaderToolbar>
                    <HeaderToolbar.Breadcrumb className="mr-auto">
                        <Breadcrumb.Item>Resources</Breadcrumb.Item>
                        <Breadcrumb.Item onClick={handleGuideManagementLinkClick}>Guide Management</Breadcrumb.Item>
                        <Breadcrumb.Item>Global Settings</Breadcrumb.Item>
                    </HeaderToolbar.Breadcrumb>
                </HeaderToolbar>
                <ColumnLayout.Fill>
                    <GlobalSettings />
                </ColumnLayout.Fill>
            </ColumnLayout>
        </Page>
    );
};
